import jQuery from 'jquery';

(function ($) {

    $.tinyRte = function (element, options) {
        // use strict mode only
        "use strict";

        // variable initialization
        var plugin = this,
            $element = $(element),
            $rteContent = null,
            $rteHidden = null,
            //$fontDropDown = null,
            //$fontList = null,
            //$fontValue = null,
            $colorBtn = null,
            $colorPicker = null,
            $lAlignBtn = null,
            $cAlignBtn = null,
            $rAlignBtn = null,
            $varsDropDown = null,
            $varsList = null;

        // settings for the plugin (these are not considered as of yet)
        plugin.settings = $.extend({
            mode: "simple",
            backgroundColor: "white",
            fontColor: "black"
        }, options);

        // Initialize the plugin for the current instance
        plugin.init = function () {
            plugin.setUniqueId();
            plugin.gatherElements();
            plugin.setInitialContent();
        };

        // sets a unique id per rte element
        plugin.setUniqueId = function () {
            var elementId = Math.random().toString(36).substr(2, 9);

            $element.attr('id', elementId);
        };

        // gathers all elements and sets the values (kinda like a constructor)
        plugin.gatherElements = function () {
            $rteContent = $element.find($('.tiny-rte-content'));
            $rteHidden = $element.find($('.tiny-rte-hidden'));
            //$fontDropDown = $element.find($('.font-drop-down'));
            //$fontList = $element.find($('.font-list'));
            //$fontValue = $element.find($('.font-value'));
            $colorBtn = $element.find($('.color'));
            $colorPicker = $element.find($('.color-picker'));
            $lAlignBtn = $element.find($('.align-left'));
            $cAlignBtn = $element.find($('.align-center'));
            $rAlignBtn = $element.find($('.align-right'));
            $varsDropDown = $element.find($('.variables'));
            $varsList = $element.find($('.variables-list'));
        };

        // setting the given content to the hidden input field
        plugin.setInitialContent = function () {
            $rteHidden.val($rteContent.html().trim());
        };

        // sets content to a specific element
        plugin.setElementContent = function ($element) {
            $rteContent = $element.find($('.tiny-rte-content'));
            $rteHidden = $element.find($('.tiny-rte-hidden'));

            $rteHidden.val($rteContent.html().trim());
        };

        // set all events for all function buttons
        plugin.setEvents = function () {
            /*$fontDropDown.click(function () {
                $fontList.toggleClass('hidden');
                $(this).toggleClass('active');

                return false;
            });*/

            /*$fontValue.click(function () {
                $fontList.toggleClass('hidden');
                $fontDropDown.toggleClass('active');

                document.execCommand('fontName', false, $(this).data('font-name'));

                $rteContent.focus();

                return false;
            });*/

            $colorBtn.click(function () {
                $colorPicker.click();

                return false;
            });

            $colorPicker.on('change', function () {
                document.execCommand('foreColor', false, $(this).val());

                return false;
            });

            $lAlignBtn.click(function () {
                document.execCommand('justifyLeft', false, null);

                $rteContent.focus();

                return false;
            });

            $cAlignBtn.click(function () {
                document.execCommand('justifyCenter', false, null);

                $rteContent.focus();

                return false;
            });

            $rAlignBtn.click(function () {
                document.execCommand('justifyRight', false, null);

                $rteContent.focus();

                return false;
            });

            $varsDropDown.click(function () {
                $varsList.toggleClass('hidden');
                $(this).toggleClass('active');

                return false;
            });

            $element.on('blur keyup paste input mouseup', function () {
                plugin.setElementContent($(this));
            });
        };

        // run the plugin
        plugin.init();
        plugin.setEvents();
    };

    // Initialize the plugin for all found instances of the given element (e.g.: '.tiny-rte')
    $.fn.tinyRte = function (options) {
        return this.each(function () {
            $.tinyRte(this, options);
        });
    };

}(jQuery));
